import * as Configuration from '../../../app.constants.js';

export class AddAccountService {
  constructor($http, AsyncRequestFactory) {
    this.$http = $http;
    this.AsyncRequestFactory = AsyncRequestFactory;
  }

  register360DialogAccount(companyId, formData) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/whatsapp-via-360D/register';
    return this.$http.post(url, formData);
  }

  reauthorize360DialogAccount(companyId, authId, formData) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/whatsapp-via-360D/' + authId;
    return this.$http.post(url, formData);
  }

  get360DialogAuthorizationData(companyId, authId) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/whatsapp-via-360D/' + authId;
    return this.$http.get(url);
  }

  static AddAccountFactory($http, AsyncRequestFactory) {
    return new AddAccountService($http, AsyncRequestFactory);
  }

  registerLineAccount(companyId, formData) {
    const url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/line/register';
    return this.$http.post(url, formData);
  }

  reauthorizeLineAccount(companyId, authId, formData) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/line/' + authId;
    return this.$http.post(url, formData);
  }

  getLineAuthorizationData(companyId, authId) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/line/' + authId;
    return this.$http.get(url);
  }

  registerLineMulesoftAccount(companyId, formData) {
    const url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/line-mulesoft/register';
    return this.$http.post(url, formData);
  }

  reauthorizeLineMulesoftAccount(companyId, authId, formData) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/line-mulesoft/' + authId;
    return this.$http.post(url, formData);
  }

  getLineMulesoftAuthorizationData(companyId, authId) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/line-mulesoft/' + authId;
    return this.$http.get(url);
  }

  registerKakaotalkAccount(companyId, formData) {
    const url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/kakaotalk/register';
    return this.$http.post(url, formData);
  }

  reauthorizeKakaotalkAccount(companyId, authId, formData) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/kakaotalk/' + authId;
    return this.$http.post(url, formData);
  }

  getKakaotalkAuthorizationData(companyId, authId) {
    let url = Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/kakaotalk/' + authId;
    return this.$http.get(url);
  }
}

AddAccountService.AddAccountFactory.$inject = ['$http', 'AsyncRequestFactory'];

